import React from "react";
import "./faq.scss";

export default function Faq(props) {
  const faqData = props.faqData;
  return (
    <div className="container-fluid faq-component">
    <h2 className="text-center">Frequently Asked Questions</h2>
      <div className="accordion accordion-flush" id="accordionFlushExample">
      {faqData.map((data,index)=>(
          <div className="accordion-item">
        
          <h2 className="accordion-header" id={`flush-heading${index}`}>
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#flush-collapse${index}`}
              aria-expanded="false"
              aria-controls={`flush-collapse${index}`}
            >
              {data.heading}
            </button>
          </h2>
          <div
            id={`flush-collapse${index}`}
            className="accordion-collapse collapse"
            aria-labelledby={`flush-heading${index}`}
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              {data.description}
            </div>
          </div>
        </div>
        ))}
      </div>
    </div>
  );
}
